/**
 * CFDI 4.0 Facturación Electrónica API Client (#877)
 *
 * admin#2639 계약: 자진발급은 조회 증거(lookup_token, HMAC-SHA256, 15분) 필수.
 * - lookup 성공 시 data.lookup_token·data.lookup_token_expires_in(900) 수신·보관
 * - lookup 실패는 후보 없음·합계 불일치 모두 404 단일(합계 불일치 422 폐지),
 *   409 복수후보는 유지되어 별도 처리한다
 * - issue POST body에 lookup_token 필수, show GET은 ?lookup_token= 쿼리 전달
 */
import { apiClient } from './client';

export interface FacturacionOrderLookupParams extends Record<string, string | number | boolean | undefined> {
  store_id?: number | string;
  order_id?: number | string;
  order_number?: string;
  total: number | string;
  date?: string;
}

export interface FacturacionIssuePayload {
  lookup_token: string;
  rfc: string;
  razon_social: string;
  codigo_postal: string;
  regimen_fiscal: string;
  uso_cfdi: string;
  email?: string;
}

export interface CfdiInvoiceData {
  id: number;
  store_id: number;
  order_id: number;
  uuid: string;
  rfc_emisor: string;
  rfc_receptor: string;
  nombre_receptor: string;
  subtotal: number;
  tax_amount: number;
  total: number;
  currency: string;
  status: string;
  xml_url?: string;
  pdf_url?: string;
  qr_url?: string;
  stamped_at?: string;
}

export interface FacturacionLookupResponse {
  success: boolean;
  data: {
    order: {
      id: number;
      order_number: string;
      subtotal: string;
      tax: string;
      total: string;
      created_at?: string;
    };
    invoice: CfdiInvoiceData | null;
    can_invoice: boolean;
    lookup_token: string;
    lookup_token_expires_in: number;
  };
}

export interface FacturacionIssueResponse {
  success: boolean;
  message?: string;
  data: CfdiInvoiceData;
}

export const facturacionApi = {
  lookupOrder: (params: FacturacionOrderLookupParams): Promise<FacturacionLookupResponse> => {
    return apiClient.get<FacturacionLookupResponse>('/api/v1/facturacion/orders/lookup', { params });
  },

  issueInvoice: (
    orderId: number | string,
    data: FacturacionIssuePayload
  ): Promise<FacturacionIssueResponse> => {
    return apiClient.post<FacturacionIssueResponse>(`/api/v1/orders/${orderId}/facturacion`, data);
  },

  getInvoice: (
    orderId: number | string,
    lookupToken: string
  ): Promise<FacturacionIssueResponse> => {
    return apiClient.get<FacturacionIssueResponse>(`/api/v1/orders/${orderId}/facturacion`, {
      params: { lookup_token: lookupToken },
    });
  },
};
